import {
  Box,
  Button,
  Container,
  Flex,
  Input,
  Menu,
  Select,
  Text,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AddButton from "../../../components/AddButton";
import NoteModal from "../../../components/NoteModal";
import NoteTypeSelectModal from "../../../components/NoteSelectTypeModal";
import NoteTable from "../../../components/NoteTable";
import CustomPagination from "../../../components/Pagination/CustomPagination";
import { getAllFacilitiesModal, getAllFacilityTypes } from "../../../services";
import { getAllNoteTypes, getNotes } from "../../../services/note";
import { getAllPatientsModal } from "../../../services/patient";
import { getAllStaff } from "../../../services/staff";
import moment from "moment";
import { DatePickerInput } from "@mantine/dates";
import { FilterIcon } from "../../../components/Svgs/FilterIcon";
import useStyles from "./style";
import { FaSort } from "react-icons/fa6";
import AddEssentialNote from "../../../components/AddEssentialNote/AddEssentialNote";
import { Billing_Services_Note, Essential_Support_Note } from "../../../http";
import NoteDrawer from "../../../components/NoteModal/NewNoteDesignCopy";
import { NewAddButton } from "../../../components/AddButton/NewAddButton";
import { NotetTypeSvg } from "../../../components/Svgs/NotetTypeSvg";
import { RxCross2 } from "react-icons/rx";
import { LuCalendar } from "react-icons/lu";
import { IoChevronBack, IoFilter } from "react-icons/io5";
import { IconSearch } from "@tabler/icons-react";
import NoteModalNew from "../../../components/NoteModal/NoteModalNew";

const ClientNoteview = ({ userId, activeTab }) => {
  const { classes } = useStyles();

  const [data, setData] = useState(null);
  const [view, setView] = useState(false);
  const [isopen, setOpen] = useState(false);
  const [noteType, setNoteType] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const { notes, loading } = useSelector((state) => state?.note);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [opened, { open, close }] = useDisclosure(false);
  const [dateRange, setDateRange] = useState(null);
  const [dateRangeVal, setDateRangeVal] = useState([]);
  const [oneDayValue, setOneDayValue] = useState(null);
  const [billingServices, setBillingServices] = useState("");
  const [progressNoteState, setProgressNoteState] = useState("");
  const [createdAt, setCreatedAt] = useState(null);
  const [isViewNoteOpen, setIsViewNoteOpen] = useState(false);

  const [openModal, setOpenModal] = useState(false);

  const [sortOpen, setSortOpen] = useState(false);
  const [sortField, setSortField] = useState("noteDate");
  const [sortOrder, setSortOrder] = useState("descending");

  const [activeFilters, setActiveFilters] = useState({
    facility: null,
    createdBy: null,
    noteTypeFilter: null,
    client: null,
  });
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [tempFacility, setTempFacility] = useState(null);
  const [tempCreatedBy, setTempCreatedBy] = useState(null);
  const [tempNoteType, setTempNoteType] = useState(null);
  const [tempClient, setTempClient] = useState(null);

  const { allDeletedFacilities } = useSelector((state) => state?.facility);
  const { allStaff } = useSelector((state) => state?.staff);
  const { allNotesTypes } = useSelector((state) => state?.note);
  const { allPatients } = useSelector((state) => state?.patient);
  const hasActiveFilters =
    activeFilters?.facility ||
    activeFilters?.createdBy ||
    activeFilters?.noteTypeFilter ||
    activeFilters?.client ||
    dateRange;

  useEffect(() => {
    getAllNoteTypes();
    getAllFacilityTypes();
    // getAllPatientsModal();
    getAllFacilitiesModal("all");
  }, []);

  useEffect(() => {
    if (activeTab === "notes") {
      getAllStaff("all");
    }
  }, [activeTab]);

  // useEffect(() => {
  //   getNotes(currentPage, userId, true, dateRange, sortField, sortOrder);
  // }, [currentPage, dateRange]);
  useEffect(() => {
    getNotes(
      currentPage,
      userId,
      true,
      dateRange,
      sortField,
      sortOrder,
      undefined,
      activeFilters,
    );
  }, [currentPage, dateRange, activeFilters]);

  const handleDateRange = (dates) => {
    if (dates[0] == null && dates[1] == null) {
      setDateRangeVal([]);
    } else {
      setDateRangeVal(dates);
    }
  };

  const handleDateChange = (date) => {
    setOneDayValue(date);
  };

  // const handleCreatedAt = (date) => {
  //   let startDate = moment(dateRangeVal[0]);
  //   setCreatedAt()
  // };

  const handleSaveDateRange = () => {
    if (dateRangeVal?.length) {
      let startDate = moment(dateRangeVal[0]).startOf("day");
      let endDate = moment(dateRangeVal[1]).endOf("day");
      setDateRange([startDate, endDate]);
    } else if (oneDayValue) {
      let startDate = moment(oneDayValue).startOf("day");
      let endDate = moment(oneDayValue).endOf("day");
      setDateRange([startDate, endDate]);
    }
    setDropdownOpen(false);
  };

  const handleCancelDateRange = () => {
    setDateRangeVal([]);
    setDateRange(null);
    setDropdownOpen(false);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSortChange = (field, order) => {
    setSortField(field);
    setSortOrder(order);
  };

  // const handleAddEssential = () => {
  //   setNoteType(Essential_Support_Note);
  //   setOpen(true);
  // };

  const getFacilityName = (id) => {
    const fac = allDeletedFacilities?.facilities?.find((f) => f.id === id);
    return fac?.name || id;
  };

  const getStaffName = (id) => {
    const staff = allStaff?.find((s) => s?.id === id);
    return (
      staff?.name ||
      `${staff?.firstName || ""} ${staff?.lastName || ""}`.trim() ||
      id
    );
  };

  const getNoteTypeName = (id) => {
    const nt = allNotesTypes?.ntypes?.find((n) => n?.id === id);
    return nt?.name || id;
  };

  const getClientName = (id) => {
    const patient = allPatients?.find((p) => p?.id === id);
    return patient?.name || id;
  };

  const handleApplyFilter = () => {
    const newFilters = { ...activeFilters };
    if (selectedCategory === "facility" && tempFacility) {
      newFilters.facility = tempFacility;
    }
    if (selectedCategory === "staff" && tempCreatedBy) {
      newFilters.createdBy = tempCreatedBy;
    }
    if (selectedCategory === "noteType" && tempNoteType) {
      newFilters.noteTypeFilter = tempNoteType;
    }
    // if (selectedCategory === "client" && tempClient) {
    //   newFilters.client = tempClient;
    // }
    if (selectedCategory === "date") {
      handleSaveDateRange();
    }
    setActiveFilters(newFilters);
    setCurrentPage(1);
    setDropdownOpen(false);
    setSelectedCategory(null);
  };

  const handleResetAllFilters = () => {
    setActiveFilters({
      facility: null,
      createdBy: null,
      noteTypeFilter: null,
      // client: null,
    });
    setDateRange(null);
    setDateRangeVal([]);
    setOneDayValue(null);
    setTempFacility(null);
    setTempCreatedBy(null);
    setTempNoteType(null);
    // setTempClient(null);
    setSelectedCategory(null);
    setCurrentPage(1);
    setDropdownOpen(false);
  };

  const handleRemoveFilter = (key) => {
    if (key === "date") {
      setDateRange(null);
      setDateRangeVal([]);
      setOneDayValue(null);
      setCurrentPage(1);
    } else {
      setActiveFilters((prev) => ({ ...prev, [key]: null }));
      setCurrentPage(1);
    }
  };

  const handleAddEssential = () => {
    if (billingServices) {
      setNoteType(Billing_Services_Note);
    } else {
      setNoteType(Essential_Support_Note);
    }
    setOpen(true);
  };
  return (
    <Container fluid className={classes.content} px={20}>
      {/* Note Modal */}
      <AddEssentialNote
        openModal={openModal}
        setOpenModal={setOpenModal}
        onConfirm={handleAddEssential}
        billingServices={billingServices}
        setBillingServices={setBillingServices}
      />
      <NoteDrawer
        close={() => {
          setOpen(false);
          setData(null);
          setNoteType(null); // Reset note type
        }}
        // view={view}
        data={data}
        userId={userId}
        opened={isopen}
        setView={setView}
        noteType={noteType}
        title={"Add New Note"}
        setOpenModal={setOpenModal}
        setBillingServices={setBillingServices}
        setProgressNoteState={setProgressNoteState}
        progressNoteState={progressNoteState}
      />
      <NoteModalNew
        opened={isViewNoteOpen}
        close={() => {
          setIsViewNoteOpen(false);
          setData(null);
        }}
        hideApproveRejectButtons={true}
        noteType={noteType}
        title={"Add New Note"}
        view={view}
        setView={setView}
        data={data}
      />

      {/* Filter and Add Button */}
      <Box className={classes.btn}>
        <Flex align={"center"} gap={10}>
          <Flex align={"center"} gap={10}>
            <Text className={classes.titleText}>All Notes</Text>
          </Flex>
          {/* <Box className={classes.FilterIcon}>
            <Menu
              width={350}
              shadow="md"
              opened={sortOpen}
              position="bottom-start"
              onClose={() => setSortOpen(false)}
            >
              <Menu.Target title="Sort">
                <Box
                  className={classes.FilterIcon}
                  onClick={() => setSortOpen(!sortOpen)}
                >
                  <FaSort size={30} />
                </Box>
              </Menu.Target>

              <Menu.Dropdown>
                <Text size="md" weight={500} ml={5} mt={10} mb={5}>
                  Sorting
                </Text>
                <Select
                  label="Sort By"
                  placeholder="Sort by"
                  data={[
                    { label: "Created Date", value: "createdAt" },
                    { label: "Note Date", value: "noteDate" },
                    { label: "Edited Date", value: "updatedAt" },
                  ]}
                  value={sortField}
                  onChange={(value) => handleSortChange(value, sortOrder)}
                />
                <Select
                  label="Sort Order"
                  placeholder="Sort Order"
                  data={[
                    { label: "Ascending", value: "ascending" },
                    { label: "Descending", value: "descending" },
                  ]}
                  value={sortOrder}
                  onChange={(value) => handleSortChange(sortField, value)}
                />
                <Box className={classes.filterBtn}>
                  <Button
                    size="sm"
                    radius={8}
                    color="yellow"
                    disabled={loading}
                    onClick={() =>
                      getNotes(
                        currentPage,
                        null,
                        true,
                        dateRange,
                        sortField,
                        sortOrder
                      )
                    }
                  >
                    Save
                  </Button>
                </Box>
              </Menu.Dropdown>
            </Menu>
          </Box> */}
        </Flex>

        <Box className={classes.rightBTN}>
          <Menu
            width={350}
            shadow="md"
            radius={"md"}
            opened={dropdownOpen}
            position="bottom"
            onClose={() => {
              setDropdownOpen(false);
              setSelectedCategory(null);
            }}
          >
            <Menu.Target title="Filter">
              <Button
                size="md"
                radius="md"
                title="Filter"
                leftIcon={<IoFilter />}
                onClick={() => setDropdownOpen(!dropdownOpen)}
                color="gray"
                variant="outline"
              >
                Filter
              </Button>
            </Menu.Target>

            <Menu.Dropdown>
              {!selectedCategory ? (
                <>
                  <Box className={classes.box_header}>
                    <Text size="lg" weight={500}>
                      Filter
                    </Text>
                    <Button
                      variant="unstyled"
                      p={0}
                      onClick={() => setDropdownOpen(false)}
                    >
                      <RxCross2 />
                    </Button>
                  </Box>
                  <Box className={classes.filterCategoryList}>
                    <Box
                      className={classes.filterCategoryItem}
                      onClick={() => {
                        setSelectedCategory("facility");
                        setTempFacility(activeFilters.facility);
                      }}
                    >
                      <Text>Facility</Text>
                      {activeFilters.facility && (
                        <Box className={classes.activeFilterDot} />
                      )}
                    </Box>
                    <Box
                      className={classes.filterCategoryItem}
                      onClick={() => {
                        setSelectedCategory("staff");
                        setTempCreatedBy(activeFilters.createdBy);
                      }}
                    >
                      <Text>Staff Name</Text>
                      {activeFilters.createdBy && (
                        <Box className={classes.activeFilterDot} />
                      )}
                    </Box>
                    <Box
                      className={classes.filterCategoryItem}
                      onClick={() => {
                        setSelectedCategory("noteType");
                        setTempNoteType(activeFilters.noteTypeFilter);
                      }}
                    >
                      <Text>Note Type</Text>
                      {activeFilters.noteTypeFilter && (
                        <Box className={classes.activeFilterDot} />
                      )}
                    </Box>
                    <Box
                      className={classes.filterCategoryItem}
                      onClick={() => setSelectedCategory("date")}
                    >
                      <Text>Date</Text>
                      {dateRange && <Box className={classes.activeFilterDot} />}
                    </Box>
                  </Box>
                  <Box className={classes.btn_container}>
                    <Button
                      size="sm"
                      radius={"md"}
                      color="gray"
                      variant="outline"
                      onClick={handleResetAllFilters}
                    >
                      Reset All
                    </Button>
                  </Box>
                </>
              ) : (
                <>
                  <Box
                    className={classes.filterCategoryHeader}
                    onClick={() => setSelectedCategory(null)}
                  >
                    <IoChevronBack size={16} />
                    <Text weight={600}>
                      {selectedCategory === "facility" && "Facility"}
                      {selectedCategory === "staff" && "Staff Name"}
                      {selectedCategory === "noteType" && "Note Type"}
                      {selectedCategory === "date" && "Date"}
                    </Text>
                  </Box>
                  <Box className={classes.box_body}>
                    {selectedCategory === "facility" && (
                      <Box className={classes.filterFields}>
                        <Select
                          label="Select Facility"
                          placeholder="Search facility..."
                          searchable
                          clearable
                          value={tempFacility}
                          onChange={setTempFacility}
                          data={
                            allDeletedFacilities?.facilities
                              ?.filter(
                                (p) =>
                                  p?.active === true && p?.deleted === false,
                              )
                              ?.map((f) => ({
                                label: f?.name,
                                value: f?.id,
                              })) || []
                          }
                        />
                      </Box>
                    )}
                    {selectedCategory === "staff" && (
                      <Box className={classes.filterFields}>
                        <Select
                          label="Select Staff"
                          placeholder="Search staff..."
                          searchable
                          clearable
                          value={tempCreatedBy}
                          onChange={setTempCreatedBy}
                          data={
                            allStaff
                              ?.filter(
                                (p) =>
                                  p?.active === true && p?.deleted === false,
                              )
                              ?.map((s) => ({
                                label:
                                  s?.name ||
                                  `${s?.firstName || ""} ${s?.lastName || ""}`.trim(),
                                value: s?.id,
                              })) || []
                          }
                        />
                      </Box>
                    )}
                    {selectedCategory === "noteType" && (
                      <Box className={classes.filterFields}>
                        <Select
                          label="Select Note Type"
                          placeholder="Search note type..."
                          searchable
                          clearable
                          value={tempNoteType}
                          onChange={setTempNoteType}
                          data={
                            allNotesTypes?.ntypes?.map((n) => ({
                              label: n?.name,
                              value: n?.id,
                            })) || []
                          }
                        />
                      </Box>
                    )}
                    {selectedCategory === "date" && (
                      <>
                        <Box className={classes.filterFields}>
                          <DatePickerInput
                            size="sm"
                            radius={"md"}
                            clearable
                            type="range"
                            value={dateRangeVal}
                            disabled={oneDayValue}
                            label="Select Date Range"
                            onChange={handleDateRange}
                            placeholder="Select Date Range"
                          />
                        </Box>
                        <Box className={classes.filterFields}>
                          <DatePickerInput
                            radius={"md"}
                            clearable
                            size="sm"
                            value={oneDayValue}
                            label="Select Date"
                            placeholder="Select Date"
                            onChange={handleDateChange}
                            disabled={dateRangeVal?.length}
                          />
                        </Box>
                      </>
                    )}
                  </Box>
                  <Box className={classes.btn_container}>
                    <Button
                      size="sm"
                      radius={"md"}
                      color="gray"
                      variant="outline"
                      onClick={() => {
                        if (selectedCategory === "facility")
                          setTempFacility(null);
                        // if (selectedCategory === "client") setTempClient(null);
                        if (selectedCategory === "staff")
                          setTempCreatedBy(null);
                        if (selectedCategory === "noteType")
                          setTempNoteType(null);
                        if (selectedCategory === "date") {
                          setDateRangeVal([]);
                          setOneDayValue(null);
                        }
                      }}
                    >
                      Reset
                    </Button>
                    <Button
                      radius={"md"}
                      size="sm"
                      disabled={loading}
                      onClick={handleApplyFilter}
                      style={{
                        backgroundColor: "#000",
                      }}
                    >
                      Apply
                    </Button>
                  </Box>
                </>
              )}
            </Menu.Dropdown>
          </Menu>
          <NewAddButton
            title="Add Note"
            icon={<NotetTypeSvg />}
            onClick={() => {
              getAllStaff("all");
              setOpen(true);
            }}
            color="#FFAF4A"
            textColor="#000"
            variant="filled"
            borderColor="none"
          />
        </Box>
      </Box>
      <Box className={classes.table}>
        <Box>
          <Input
            className={classes.searchInput}
            variant="filled"
            size="sm"
            placeholder="Search"
            icon={<IconSearch />}
            mb={10}
          />
          {hasActiveFilters && (
            <Box className={classes.activeFiltersBar} px={20} mx={20}>
              {activeFilters.facility && (
                <Box className={classes.filterChip}>
                  <Text size="xs">
                    Facility: {getFacilityName(activeFilters.facility)}
                  </Text>
                  <RxCross2
                    size={12}
                    onClick={() => handleRemoveFilter("facility")}
                  />
                </Box>
              )}
              {activeFilters.createdBy && (
                <Box className={classes.filterChip}>
                  <Text size="xs">
                    Staff: {getStaffName(activeFilters.createdBy)}
                  </Text>
                  <RxCross2
                    size={12}
                    onClick={() => handleRemoveFilter("createdBy")}
                  />
                </Box>
              )}
              {activeFilters.noteTypeFilter && (
                <Box className={classes.filterChip}>
                  <Text size="xs">
                    Note Type: {getNoteTypeName(activeFilters.noteTypeFilter)}
                  </Text>
                  <RxCross2
                    size={12}
                    onClick={() => handleRemoveFilter("noteTypeFilter")}
                  />
                </Box>
              )}
              {dateRange && (
                <Box className={classes.filterChip}>
                  <Text size="xs">
                    Date: {moment(dateRange[0]).format("MM/DD/YY")} -{" "}
                    {moment(dateRange[1]).format("MM/DD/YY")}
                  </Text>
                  <RxCross2
                    size={12}
                    onClick={() => handleRemoveFilter("date")}
                  />
                </Box>
              )}
              <Text
                className={classes.clearAllLink}
                onClick={handleResetAllFilters}
              >
                Clear all
              </Text>
            </Box>
          )}
          <NoteTable
            openModal={(data) => {
              setData(data);
              setOpen(true);
            }}
            openViewModal={(data) => {
              setData(data);
              setIsViewNoteOpen(true);
            }}
            setView={(data) => {
              setView(true);
            }}
            userId={userId}
            loading={loading}
          />
        </Box>
        <CustomPagination
          itemsPerPage={10}
          data={notes?.count}
          currentPage={currentPage}
          handlePageChange={handlePageChange}
        />
      </Box>
    </Container>
  );
};

export default ClientNoteview;
